import { Component, OnInit } from '@angular/core';
import { Chapter } from '../../../models/chapter';
import { ChapterService } from '../../../services/chapter.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { ChapterPagesComponent } from './chapter-pages/chapter-pages.component';

@Component({
    selector: 'sidebar-pages-content',
    templateUrl: './pages-content.component.html',
    styleUrls: ['./pages-content.component.scss'],
    standalone: true,
    imports: [
        ChapterPagesComponent
    ]
})
export class PagesContentComponent implements OnInit {

    mainChapters: Array<Chapter>;

    constructor(public applicationStateService: ApplicationStateService,
                private chapterService: ChapterService) {
    }

    ngOnInit(): void {
        this.chapterService.getChapters().then(allChapters => {

            const mainChapters = allChapters;

            if (!mainChapters || mainChapters.length === 0) {
                const singleChapter = new Chapter();
                singleChapter.title = 'Alle Seiten';
                singleChapter.index = 1;
                this.mainChapters = [singleChapter];

                return;
            }

            // copy array
            this.mainChapters = mainChapters.map(ele => ele);

            if (this.mainChapters[0].index > 0) {
                const singleChapter = new Chapter();
                singleChapter.index = 0;
                this.mainChapters.unshift(singleChapter);
            }
        });
    }
}
